import {
    Box,
    FormControlLabel,
    FormLabel,
    IconButton,
    Menu,
    Radio,
    RadioGroup
} from "@mui/material";
import {
    Dispatch,
    SetStateAction,
    useState
} from "react";

import { SortDirection } from "../../lib/sorting/SortDirection";
import SortIcon from '@mui/icons-material/Sort';

type ContactListSortMenuProps = {
    sortDirection: SortDirection;
    setSortDirection: Dispatch<SetStateAction<SortDirection>>;
};

export const ContactListSortMenu = (props: ContactListSortMenuProps) => {
    const { sortDirection, setSortDirection } = props;

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const isMenuOpen = Boolean(anchorEl);
    const onOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const onCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleSortDirectionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSortDirection(event.target.value as SortDirection);
    };

    return (
        <>
            <IconButton
                onClick={onOpenMenu}
            >
                <SortIcon />
            </IconButton>
            <Menu
                open={isMenuOpen}
                anchorEl={anchorEl}
                onClose={onCloseMenu}
            >
                <Box display="flex" flexDirection="column" gap={2} px={2} py={1}>
                    <FormLabel>
                        Sort Direction
                    </FormLabel>
                    <RadioGroup
                        value={sortDirection}
                        onChange={handleSortDirectionChange}
                    >
                        <FormControlLabel
                            value={SortDirection.ASCENDING}
                            control={<Radio />}
                            label="Ascending"
                        />
                        <FormControlLabel
                            value={SortDirection.DESCENDING}
                            control={<Radio />}
                            label="Descending"
                        />
                    </RadioGroup>
                </Box>
            </Menu>
        </>
    );
};